import { render, staticRenderFns } from "./InvitationsTemplate.vue?vue&type=template&id=19e67852&scoped=true&"
import script from "./InvitationsTemplate.vue?vue&type=script&lang=js&"
export * from "./InvitationsTemplate.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsTemplate.vue?vue&type=style&index=0&id=19e67852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e67852",
  null
  
)

export default component.exports